export function pad(x, padding = 2) {
  return x.toString().padStart(padding, "0");
}
